import * as Sentry from '@sentry/nextjs'

const isExtensionUrl = (url?: string | null) => {
  if (!url) return false

  return (
    url.startsWith('chrome-extension://')
    || url.startsWith('moz-extension://')
    || url.startsWith('safari-extension://')
  )
}

export const beforeSendToSentry = (event: Sentry.Event, hint: Sentry.EventHint): any => {
  void hint

  const exceptionValues = event.exception?.values || []

  // Drop known browser noise
  const shouldDrop = exceptionValues.some(r =>
    r.value?.includes('ResizeObserver')
    || r.value?.includes('NotAllowedError: play()')
  )
  if (shouldDrop) return null

  // Drop browser extension errors
  const frames = exceptionValues.flatMap(value => value.stacktrace?.frames || [])
  const hasExtensionFrame = frames.some(frame => isExtensionUrl(frame.filename))
  if (hasExtensionFrame || isExtensionUrl(event.request?.url)) return null

  return event
}
